import script from "./CommodityGroupItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CommodityGroupItem.vue?vue&type=script&setup=true&lang=js"

import "./CommodityGroupItem.vue?vue&type=style&index=0&id=6168552a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6168552a"]])

export default __exports__